<template lang="pug">
  .product-image
    .zoom(ref="zoom")
    // TODO: fix lazy loading
    // see: src/extensions/shop/sections/CategoryProducts/Teaser.vue
    // .observer
    //   lazy-component(@show="show")
    //     img(:src="image.src")
    // figure.image(
    //   :style="{ 'width': `${w}px`, 'height': `${h}px`, 'background-image': `url(${image.blurry})` }"
    //   :class="{ loaded }"
    // )
    //   img(
    //     ref="image"
    //     :src="image.src"
    //     :data-zoom="image.cdn"
    //     :class="{ loaded }"
    //   )
    Picture(
      v-if="media.image"
      :show-spinner="false"
      :image="media.image"
      :lazy="true"
      missing-icon="exclamation-triangle"
      fit="fit"
      optimize="speed"
      :style="style"
    )
</template>

<script>
// import Drift from 'drift-zoom';

import PreviewImage from './PreviewImage';

export default {
  name: 'ProductImage',
  extends: PreviewImage,
  mounted() {
    // new Drift(this.$refs.image, {
    //   paneContainer: document.querySelector('.zoom-container'),
    //   inlinePane: false
    // });
  }
};
</script>

<style lang="sass" scoped>
.product-image
  display: flex
  justify-content: center
.picture-container
  @apply shadow-xl rounded overflow-hidden
  background-position: center
  background-repeat: no-repeat
  background-size: cover
  width: 100%
</style>
